import Configuration from './../../../../../config/configuration';
import OnboardSolution from '../../../../../assets/image/Domains/Railways/onboarding_solutions.webp'
import TracksideSolution from '../../../../../assets/image/Domains/Railways/trackside_solutions.webp'
import DashboardSolution from '../../../../../assets/image/Domains/Railways/dashboard_solutions.webp'
import OnboardSolutionMobile from '../../../../../assets/image/Domains/Railways/onboarding_solutions_mobile.webp'
import TracksideSolutionMobile from '../../../../../assets/image/Domains/Railways/trackside_solutions_mobile.webp'
import DashboardSolutionMobile from '../../../../../assets/image/Domains/Railways/dashboard_solutions_mobile.webp'

// const OnboardSolution = `${Configuration.S3_URL}Domains/Railways/onboard_solution_1.webp`
// const DashboardSolution = `${Configuration.S3_URL}Domains/Railways/dashboard_solution_1.webp`
// const TracksideSolution = `${Configuration.S3_URL}Domains/Railways/trackside_solution_1.webp`
// const OnboardSolutionMobile = `${Configuration.S3_URL}Domains/Railways/onboard-solution-mobile.webp`
// const DashboardSolutionMobile = `${Configuration.S3_URL}Domains/Railways/dashboard-solution-mobile.webp`
// const TracksideSolutionMobile = `${Configuration.S3_URL}Domains/Railways/trackside-solution-mobile.webp`

export const RailwayDomain = {
    heading: (
        <>
            NEXT-GEN   <span style={{ color: "var(--primary-color)" }}> RAILWAY <br /> SOLUTIONS</span>
        </>
    ),
     mobHeading: (
        <>
            NEXT-GEN   <span style={{ color: "var(--primary-color)" }}> RAILWAY  SOLUTIONS</span>
        </>
    ),
    subHeading:
        "Transforming rail transport through the integration of intelligent technologies across onboard systems, trackside infrastructure, and station operations creating a smarter, safer, and more efficient railway ecosystem.",
    solutions: ["Onboard Solutions", "Trackside Solutions", "Dashboard Solutions"],
    buttonText: "Explore More",
};

export const RailwayDomainProjects = [

    {
        product: <>ONBOARD <span style={{ color: "var(--primary-color)" }}>SOLUTIONS</span></>,
        image: OnboardSolution,
        mobileimage: OnboardSolutionMobile,
    },
    {
        product: <>TRACKSIDE <span style={{ color: "var(--primary-color)" }}>SOLUTIONS</span></>,
        image: TracksideSolution,
        mobileimage: TracksideSolutionMobile,
    },
    {
        product: <>DASHBOARD <span style={{ color: "var(--primary-color)" }}>SOLUTIONS</span></>,
        image: DashboardSolution,
        mobileimage: DashboardSolutionMobile,

    }

]